<template>
  <div>
    <spinner-component :loaded="loading"></spinner-component>

    <v-container>
      <error-dialog-component :model-value="this.errorDialog"></error-dialog-component>
      <v-col>
        <v-btn
            block
            color="primary"
            elevation="1"
            @click="createNewVoucherGroup"
        >
          Dodaj nowy kod rabatowy
        </v-btn>
      </v-col>
      <v-row>
        <v-col>
          <v-data-table
              class="elevation-1"
              :headers="headers"
              :items="parsedVoucherGroups"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-options': [10, 25, 50]
              }"
          >
            <template v-slot:[`item.parameters`]="{ item }">
              <div v-if="item.parameters" class="parameter-cell">
                <div v-if="item.type === 'PERCENTAGE'" class="parameter-content">
                  <div class="parameter-item"><strong>%:</strong> {{ item.parameters.percentage }}%</div>
                  <div v-if="item.parameters.maximumValue" class="parameter-item"><strong>Max:</strong> {{ item.parameters.maximumValue }}</div>
                  <div v-if="item.parameters.freeShipping" class="parameter-item"><strong>Darmowa wysyłka:</strong> Tak</div>
                  <div v-if="item.parameters.freeDedications" class="parameter-item"><strong>Darmowe dedykacje:</strong> Tak</div>
                </div>
                <div v-else-if="item.type === 'VALUE'" class="parameter-content">
                  <div class="parameter-item"><strong>Wartość:</strong> {{ item.parameters.value }}</div>
                  <div v-if="item.parameters.freeShipping" class="parameter-item"><strong>Darmowa wysyłka:</strong> Tak</div>
                  <div v-if="item.parameters.freeDedications" class="parameter-item"><strong>Darmowe dedykacje:</strong> Tak</div>
                </div>
                <div v-else-if="item.type === 'BARTER'" class="parameter-content">
                  <div class="parameter-item">Barter</div>
                </div>
                <div v-else class="parameter-content">
                  {{ JSON.stringify(item.parameters) }}
                </div>
              </div>
              <div v-else>-</div>
            </template>

            <template v-slot:[`item.conditions`]="{ item }">
              <div v-if="item.conditions">
                <div v-if="item.conditions.allCondition && item.conditions.allCondition.all">
                  <strong>Wszystkie produkty:</strong> Tak
                </div>
                <div v-else>
                  <div v-if="item.conditions.categoryCondition">
                    <strong>Kategoria:</strong> {{ item.conditions.categoryCondition }}
                  </div>
                  <div v-if="item.conditions.typeCondition">
                    <strong>Typ:</strong> {{ item.conditions.typeCondition }}
                  </div>
                  <div v-if="item.conditions.productsCondition">
                    <strong>Produkty:</strong> {{ item.conditions.productsCondition }}
                  </div>
                </div>
              </div>
              <div v-else>-</div>
            </template>

            <template v-slot:[`item.limitations`]="{ item }">
              <div v-if="item.limitations">
                <div v-if="item.limitations.timeLimit">
                  <strong>Czas:</strong> {{ item.limitations.timeLimit }}
                </div>
                <div v-if="item.limitations.valueLimit">
                  <strong>Wartość:</strong> {{ item.limitations.valueLimit }}
                </div>
                <div v-if="!item.limitations.timeLimit && !item.limitations.valueLimit">
                  Brak ograniczeń
                </div>
              </div>
              <div v-else>-</div>
            </template>

            <template v-slot:[`item.active`]="{ item }">
              <v-chip :color="item.active ? 'green' : 'red'" small>
                {{ item.active ? 'Aktywny' : 'Nieaktywny' }}
              </v-chip>
            </template>

            <template v-slot:[`item.barter`]="{ item }">
              <v-chip :color="item.barter ? 'orange' : 'grey'" small>
                {{ item.barter ? 'Tak' : 'Nie' }}
              </v-chip>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                  >
                    Akcje
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-btn
                        color="primary"
                        elevation="1"
                        @click="viewVoucherCodes(item.id)"
                    >
                      Kody
                    </v-btn>
                  </v-list-item>
                  <v-list-item>
                    <v-btn
                        color="primary"
                        elevation="1"
                        @click="editVoucherGroup(item.id)"
                    >
                      Edytuj
                    </v-btn>
                  </v-list-item>
                  <v-list-item>
                    <v-btn
                        color="primary"
                        elevation="1"
                        @click="deleteVoucher(item)"
                    >
                      Usuń
                    </v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>


import {vouchersApiClient} from "@/api/vouchers.api.client";
import ErrorDialogComponent from "@/components/ErrorDialogComponent.vue";

export default {
  name: 'VouchersView',
  inheritAttrs: false,
  components: {ErrorDialogComponent},

  data() {
    return {
      voucherGroups: [],
      headers: [
        {text: "Id", value: 'id'},
        {text: "Grupa", value: 'groupType'},
        {text: "Aktywny", value: 'active'},
        {text: "Nazwa", value: 'name'},
        {text: "Type", value: 'type'},
        {text: "Parametry", value: 'parameters', sortable: false},
        {text: "Warunki", value: 'conditions', sortable: false},
        {text: "Ograniczenia", value: 'limitations', sortable: false},
        {text: "Kody", value: 'codesCount'},
        {text: "Barter", value: 'barter'},
        {text: "Akcje", sortable: false, value: 'actions'}
      ],
      parsedVoucherGroups: [],

      // MISC
      loading: false,
      errorDialog: {
        errorMessage: "",
        visible: false
      }
    }
  },

  created() {
    this.$watch(
        () => {
          return this.$route.params.groupType;
        },
        () => {
          this.parsedVoucherGroups = [];
          this.getVouchers(this.$route.params.groupType)
        },
        // fetch the data when the view is created and the data is
        // already being observed
        {immediate: true}
    )
  },

  methods: {
    getVouchers(groupType) {
      this.loading = true;
      vouchersApiClient.getVoucherGroupsByGroupName(groupType,
          response => {
            this.voucherGroups = response.data;
            this.voucherGroups.forEach(group => {
              this.parsedVoucherGroups.push({
                id: group.id,
                groupType: group.groupType,
                active: group.active,
                name: group.name,
                type: group.type,
                parameters: group.parameters,
                conditions: group.conditions,
                limitations: group.limitations,
                codesCount: group.codes ? group.codes.length : 0,
                barter: group.barter
              })
            })
          },
          error => {
            console.error(error);
          }, () => this.loading = false);
    },

    createNewVoucherGroup() {
      this.$router.push({name: 'new-voucher', params: {groupType: this.$route.params.groupType}});
    },

    editVoucherGroup(id) {
      this.$router.push({name: 'edit-voucher', params: {groupType: this.$route.params.groupType, 'id': id}});
    },

    viewVoucherCodes(id) {
      this.$router.push({name: 'vouchers-codes', params: {groupType: this.$route.params.groupType, 'id': id}});
    },

    deleteVoucher(item) {
      this.loading = true;
      vouchersApiClient.deleteVoucherGroup(item.id, () => {
        this.parsedVoucherGroups = [];
        this.getVouchers(this.$route.params.groupType);
      }, (error) => {
        console.error(error);
      }, () => this.loading = false);
    }
  }
}
</script>

<style scoped>
.parameter-cell {
  max-width: 200px;
  font-size: 0.9em;
}

.parameter-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.parameter-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.parameter-item strong {
  color: #1976d2;
  font-weight: 600;
}
</style>
